import React, { useState, useEffect } from "react";
import Section from "../../components/UI/Section/Section";
import ProfileTabs from "../../components/User/ProfileTabs";

import { useAuth } from "../../contexts/AuthContext";

import Radar from "../../components/Radar/Radar";

import { GetUserSkillsTree } from "../../components/Database/Functions";
import { GetRealTree } from "../../components/Database/RealtimeDatabase";
import { Alert } from "react-bootstrap";
import IconList from "../../components/UI/IconList/IconList";
import Icon from "../../components/UI/Icon/Icon";
import UserPanel from "../../components/User/UserPanel";

import { useParams } from "react-router-dom";

export default () => {
  const [scoresData, setScoresData] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const { currentUser } = useAuth();

  const params = useParams();
  const userID = params.userID ? params.userID : currentUser.uid;

  // console.log('userID',params.userID);

  useEffect(() => {
    setLoading(true);

    GetUserSkillsTree(userID).then((mySkills) => {
      GetRealTree("skills").then((items) => {
        const skills = [];//merge available skills and user skills [ id: {...} ]
        const scores = []; // [1,2,4,5]
        const icons = []; // [{ score: 10, icon: "leaderboard" }],

        //merge
        for (var id in items) {
          skills[id] = {
            ...items[id],
            score: mySkills[id] !== undefined ? mySkills[id].count : 0,
          };
        }

        for (var id in skills) {
          //get scores
          scores.push(skills[id].score);
          //get icons
          icons.push({...skills[id]});
        }

        setScoresData({skills: skills, scores: scores, icons: icons});
        setLoading(false);
      });
    });
  }, []);

  return (
    <>
      {!params.userID && <UserPanel />}
      {error && <Alert variant="danger">{error}</Alert>}
      <Section>
        <ProfileTabs userID={userID}/>
      </Section>
      <Section>
        {isLoading ? "загрузка" : <Radar data={scoresData} />}
      </Section>
      <Section>
        <IconList layout="vertical">
          <Icon className="Icon-list__item" image="star2" size="xl" title="Дизайнер"/>
          <p className="Icon-list__item-desc">Выдается за выполнение творческих заданий.</p>
          <Icon className="Icon-list__item" image="bulp" size="xl" title="Инициатор"/>
          <p className="Icon-list__item-desc">Выдается за инициативу и помощь.</p>
          <Icon className="Icon-list__item" image="cog" size="xl" title="Инженер"/>
          <p className="Icon-list__item-desc">Выдается за выполнение заданий, требующих инженерных навыков.</p>
          <Icon className="Icon-list__item" image="project" size="xl" title="Проектник"/>
          <p className="Icon-list__item-desc">Выдается за разработку и выполнение собственных проектов.</p>
          <Icon className="Icon-list__item" image="smiley-talk" size="xl" title="Активист"/>
          <p className="Icon-list__item-desc">Выдается за участие в мероприятиях, популяризацию и общественную деятельность.</p>
        </IconList>
      </Section>
    </>
  );
};
